const doesElementExist = (id: string) => {
    const element = document.getElementById(id);

    return !!element;
};

export default doesElementExist;
